// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"9cada2ec","75":"cb0c3b82","102":"d4ded426","220":"a6995e1f","367":"3fe5ae1c","853":"12e64d8d","881":"94ac3187","935":"f1b4c39e","973":"16b57890"}[chunkId] + ".chunk.css";
};